import { render } from "./Complaints.vue?vue&type=template&id=194dc299&scoped=true"
import script from "./Complaints.vue?vue&type=script&lang=js"
export * from "./Complaints.vue?vue&type=script&lang=js"

import "./Complaints.vue?vue&type=style&index=0&id=194dc299&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194dc299"]])

export default __exports__